import React, { useEffect, useState } from "react";
import { Flame, TrendingUp, Repeat } from "lucide-react";
import api from "../api";

const BADGES = {
  best_seller: { label: "Best Seller", Icon: TrendingUp },
  popular_week: { label: "Popular This Week", Icon: Flame },
  reordered: { label: "Frequently Reordered", Icon: Repeat },
};

// Earned from real paid orders only (computed server-side).
export default function ProductBadges({ slug }) {
  const [badges, setBadges] = useState([]);
  useEffect(() => {
    api.get(`/products/${slug}/badges`).then(({ data }) => setBadges(data.badges || [])).catch(() => setBadges([]));
  }, [slug]);
  if (!badges.length) return null;

  return (
    <div data-testid="product-badges" className="flex flex-wrap gap-2 mt-4">
      {badges.map((k) => {
        const { label, Icon } = BADGES[k] || {};
        if (!label) return null;
        return (
          <span
            key={k}
            data-testid={`product-badge-${k}`}
            className="inline-flex items-center gap-1.5 px-3 py-1 border border-[#00C3FF]/40 bg-[#00C3FF]/5 text-[#00C3FF] font-mono-tech text-[10px] uppercase tracking-[0.2em]"
          >
            <Icon size={12} /> {label}
          </span>
        );
      })}
    </div>
  );
}
